import { ErrorBoundary } from '@components/core/ErrorBoundary';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import { Routes } from './routes';

export const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    </ErrorBoundary>
  );
};
